import { useEffect } from 'react'

import { useDataBoxSelector } from 'app/common/data-box-store'
import { DetailsBox, detailsFilter } from 'app/common/ui-next/_filter-compilations/details'
import { orgTypesFilterSelection } from 'app/dataProviders/filter-items'

type Props = { id: string; pending: boolean }

export const DetailsFilter = ({ id, pending }: Props) => {
  const orgTypes = useDataBoxSelector(
    orgTypesFilterSelection,
    () => orgTypesFilterSelection.data,
  )
  const visible = orgTypes.length > 0

  useEffect(() => {
    if (!visible) detailsFilter.resetToDefault()
  }, [visible])

  return (
    <div hidden={!visible}>
      <DetailsBox id={id} disabled={pending} />
    </div>
  )
}
